import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";
import ConfirmationModal from "../../Controls/ConfirmationModal";
import CommonFunctions from "../../../utils/helpers/CommonFunctions";

const UnRoute = (props) => {
    const { AffiliateData, GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showUnRouteAlert, setUnRouteAlert] = useState(false);
    const [unRouteAlertObj, setunRouteAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const { loginData } = useSelector((store) => store.login);
    const[selectedRecordsForARB,setSelectedRecordsForARB]=useState([]);
    const[callBackURL,setcallBackURL]=useState("");
    const[affID,setAffID]=useState(-1);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Auto Routing',
    body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
    btnOkText: 'Yes'});
    const [confirmationModalObj1, setConfirmationModalObj1] = useState({show: false, title:'Batch  UnRouting',
    body:'Batch Unroute excludes "At Location" & "Picked Up" trips. Please unroute these individually. However, other trips will be unrouted.', btnCanceText: 'Cancel',
    btnOkText: 'Ok'});
 
    useEffect(() => {
        async function fetchData(){
        if (props.GridRowData === null || props.GridRowData.length <= 0) {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'UnRoute Action', alertMsg: 'No request selected to perform Action.' , displayFooter: true});
            setUnRouteAlert(true);
        }
        else {
            //let result = await CommonFunctions.checkAutoRouting(props.selectedAffiliates, props.selectedDate, AffiliateData);
            let result = false;
            if(result){
                setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Auto Routing', body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No', btnOkText: 'Yes'}));
            }else{
                await UnRouteActions();
            }
        }

    }
            fetchData();
    }, []);

    const UnRouteActions = async() =>{
        try{
            const selectedGridData = props.GridRowData
            const affID = selectedGridData[0].iSRATSPID;
            let callBackURL = "";
            const SelectedRecordsForARB = [];
            if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                const jsonArray = GlobalASCSData;
                const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
                callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
            }
            let bschedule = "";
            for (let k = 0; k < selectedGridData.length; k++) {
                if (selectedGridData[k].Route !== "") {
                    bschedule = (typeof selectedGridData[k].bIsSchedule === "boolean" ? (selectedGridData[k].bIsSchedule === true ? true:false):(selectedGridData[k].bIsSchedule.toUpperCase() === "TRUE" ? true : false));
                    SelectedRecordsForARB.push({
                        PickupDateTime: selectedGridData[0].PickupDateTime,
                        AffiliateID: selectedGridData[k].iSRATSPID,
                        ServiceID: (!bschedule?selectedGridData[k].ServiceID:-1),
                        ScheduleID: (bschedule?selectedGridData[k].iScheduleID:-1),
                        Confirmation: selectedGridData[k].ConfirmationNo,
                        vManifestNumber: selectedGridData[k].vManifestNumber,
                        TripRequestStatus: selectedGridData[k].TripRequestStatus,
                        iAssignedVehicleId: selectedGridData[k].iAssignedVehicleId === "" ? "-1" : selectedGridData[k].iAssignedVehicleId,
                        iAssignedDriverId: selectedGridData[k].AssignedDriverId === "" ? "-1" : selectedGridData[k].AssignedDriverId,
                    });
                }
            }
            setSelectedRecordsForARB(SelectedRecordsForARB);
            setcallBackURL(callBackURL);
            setAffID(affID);
            if (SelectedRecordsForARB.length === 0) {
                setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'UnRoute', alertMsg: 'No grouped record is selected. Please select valid grouped record(s) to perform this action!' , displayFooter: true});
                setUnRouteAlert(true);
                return false;
            }

            if (props.showUnRouteActionCreate) {
                        
                if(SelectedRecordsForARB.length>1){
                if(SelectedRecordsForARB.filter(item=> item.TripRequestStatus==='PICKEDUP' || item.TripRequestStatus==='ATLOCATION').length>0){
                    setConfirmationModalObj1((prevState) => ({ ...prevState, show: true }));
                    setSelectedRecordsForARB(SelectedRecordsForARB.filter(item=> item.TripRequestStatus!=='PICKEDUP' && item.TripRequestStatus!=='ATLOCATION'));
                }
                else if (SelectedRecordsForARB.filter(item=> item.TripRequestStatus==='PICKEDUP' || item.TripRequestStatus==='ATLOCATION').length==0 && SelectedRecordsForARB.length>0){
                    const selectedDate = new Date(props.selectedDate);
                    const today = new Date();
                    const tomorrow = new Date(today);
                    tomorrow.setDate(today.getDate() + 1);

                    const selectedDateFormatted = selectedDate.toISOString().split('T')[0];
                    const todayFormatted = today.toISOString().split('T')[0];
                    const tomorrowFormatted = tomorrow.toISOString().split('T')[0];

                    const dateText = selectedDateFormatted === todayFormatted ? 'today' :
                                    selectedDateFormatted === tomorrowFormatted ? 'tomorrow' :
                                    selectedDateFormatted;

                    setConfirmationModalObj1(prevState => ({
                        ...prevState,
                        body: `You have selected ${SelectedRecordsForARB.length} trips due ${dateText}. Are you sure to Unroute?`,
                        show: true
                    }));
                }
            }
            else{
                UnRouteTrips(affID, callBackURL, SelectedRecordsForARB);

            } 
               
            }
        }
        catch(err){console.log(err);}
    }
    const UnRouteTrips = async (affID, cbURL, arrObj) => {
        props.disbaleButton(true);
        let Param = {
            "affiliate_id": affID,
            "requested_page_name": "UnClusteringAction",
            "user_id": loginData.iUserID,
            "app_id": 26,
            "object_list": JSON.stringify(arrObj),
            "call_back_url": cbURL
        }
        if(props.bCallFromActivateTrip==false || props.bCallFromActivateTrip===undefined){
        setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'Initializing UnRouting Process', alertMsg: 'Please Wait...' , displayFooter: false});
        setUnRouteAlert(true);
        }
        props.disbaleButton(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UnRoute", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if (result.run_id > 0) {
             if(props.bCallFromActivateTrip==false || props.bCallFromActivateTrip===undefined){
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'UnRouting Started', alertMsg: 'UnRouting is being performed...' , displayFooter: false});
            setUnRouteAlert(true);
            }
            props.disbaleButton(true);
        }
        else if (result.error_message !== null && result.error_message !== "" && result.error_message.includes("system") ) {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'Un-Route', alertMsg: result.error_message , displayFooter: true});
            setUnRouteAlert(true);
            props.disbaleButton(false);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'Un-Route', alertMsg: result.error_message , displayFooter: true});
            setUnRouteAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();
        }
        else {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'Un-Route', alertMsg: 'Something went wrong !!!' , displayFooter: true});
            setUnRouteAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();

        }
    }

    const handleRouteAlertClose = () => {
        setUnRouteAlert(false);
        UnMountUnRouteComponent();
    }

    const UnMountUnRouteComponent = () => {
        if (props.showRouteActionCreate) {
            props.setUnRouteActionCreate(false);
        }
    }

    const handleConfirmationModalOk = () =>{
        CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        UnRouteActions();
    }

    const handleConfirmationModalCancel = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        props.setUnRouteActionCreate(false)
    }
    
    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setUnRouteActionCreate(false)
    }

    const handleConfirmationModal1Ok = () =>{
      //  CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj1((prevState) => ({...prevState, show:false}));
        UnRouteTrips(affID, callBackURL, selectedRecordsForARB);
    }

    const handleConfirmationModal1Cancel = () =>{
        setConfirmationModalObj1((prevState) => ({...prevState, show:false}));
        props.setUnRouteActionCreate(false)
    }
    
    const handleConfirmationModal1Close = () => {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
        props.setUnRouteActionCreate(false)
    }

    return (
        <>
            {showUnRouteAlert && <Modal centered keyboard={false} show={showUnRouteAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                <Modal.Header>
                    <Modal.Title>{unRouteAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{unRouteAlertObj.alertMsg}</b></Modal.Body>
                {unRouteAlertObj.displayFooter?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRouteAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                :""}
            </Modal>}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
            onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
            btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />
            <ConfirmationModal show={confirmationModalObj1.show} Title={confirmationModalObj1.title} Body={confirmationModalObj1.body}
            onOk={handleConfirmationModal1Ok} onCancel={handleConfirmationModal1Cancel} onClose={handleConfirmationModal1Close}
             btnCanceText={confirmationModalObj1.btnCanceText}
            btnOkText={confirmationModalObj1.btnOkText} ShowCancelButton="true" />
        </>
    );

};

export default UnRoute;